import { BoxProps } from '@chakra-ui/react';
import { routes } from 'app/routing/routesConfig';
import { useLocation, useNavigate } from 'react-router-dom';
import { ButtonWithActiveState } from '../ButtonWithActiveState';

export interface LinkWithActiveStateProps extends BoxProps {
  to: string;
}

export const LinkWithActiveState = ({
  children,
  to,
}: LinkWithActiveStateProps) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isActive = pathname === to;

  const replace = [routes.playerLyrics, routes.playerPlaylist].some(
    ({ path }) => path === pathname
  );

  return (
    <ButtonWithActiveState
      isActive={isActive}
      onClick={() => {
        if (isActive) {
          navigate(-1);
        } else {
          navigate(to, { replace });
        }
      }}
    >
      {children}
    </ButtonWithActiveState>
  );
};
